import { ScenarioBuilderClient } from "@/pages/scenario-builder/api/client/scenarioClient";

type GetDateRangesV2Options = {
  scenarioBuilderClient: ScenarioBuilderClient;
  geography?: string;
};

export const getDateRangesV2 = ({ scenarioBuilderClient, geography }: GetDateRangesV2Options) => {
  return scenarioBuilderClient.validation.getScenarioValidationRules({
    geographies: geography ? [geography] : undefined,
  });
};
